"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var PasswordState = /** @class */ (function () {
    function PasswordState() {
        this.passwordValue = '';
        this.passwordErrTxt = '';
        this.isPasswordinValid = false;
        this.capsWarning = false;
        this.showHidePasswordIsHidden = true;
    }
    return PasswordState;
}());
exports.default = PasswordState;
//# sourceMappingURL=PasswordState.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/login-ui/components/panels/LoginWidget/Password/PasswordState.js
// module id = 1495
// module chunks = 8